import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faHome } from "@fortawesome/free-solid-svg-icons"

export const Home = (props) => {
  return <FontAwesomeIcon faIcon={faHome} {...props} />
}
